import {ActionIcon} from '@mantine/core';
import {AiOutlineBug} from 'react-icons/ai';
import {useEffect, useState} from 'react';
import {DebugDrawer} from '../components/DebugDrawer';
import {getVerbosityLevel} from '../../sign-in-profiles/services/SignInProfilesService';
import {VerbosityLevel} from '../../sign-in-profiles/types';

export const DebugButton = () => {
    const [opened, setOpened] = useState(false);
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        getVerbosityLevel().then(verbosity => {
            setShowButton(verbosity === VerbosityLevel.HIGH);
        });
    }, []);

    if (!showButton) return null;

    return (
        <>
            <ActionIcon
                variant="subtle"
                size="lg"
                onClick={() => setOpened(true)}
                aria-label="Debug"
            >
                <AiOutlineBug size={20}/>
            </ActionIcon>
            <DebugDrawer opened={opened} onClose={() => setOpened(false)}/>
        </>
    );
};
